<template>
  <v-form>
    <v-text-field
      type="number"
      v-model="amount"
      :label="$t('amount')"
      min="0"
      filled
      persistent-hint
      :hint="$t('couponRedemptionAmountHelpText')"
    />
  </v-form>
</template>

<script>
export default {
  name: "RedeemCoupon",
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      amount: 1
    }
  },
  watch: {
    amount(value) {
      this.$emit('input', { uuid: this.value.uuid, label: this.value.label, code: this.value.code, timesRedeemed: this.value.timesRedeemed, maxRedemptions: this.value.maxRedemptions, amount: (value * 1), active: this.value.active }) // this value will have to change when updating to vue 3
      this.$emit('valid', true)
    }
  },
    mounted() {
        this.$emit('input', { uuid: this.value.uuid, label: this.value.label, code: this.value.code, timesRedeemed: this.value.timesRedeemed, maxRedemptions: this.value.maxRedemptions, amount: this.amount, active: this.value.active }) // this value will have to change when updating to vue 3
        this.$emit('valid', true)
    }
}
</script>

<style scoped>

</style>